export const selection = {
  navigation: {
    backToHome: "Back to Home",
    login: "Login"
  },
  hero: {
    title: "Choose how you want to get started"
  },
  options: {
    existing: {
      title: "I already have a website",
      description: "Enter your website URL and AI will analyze and migrate it to the Bespire platform",
      placeholder: "https://example.com",
      button: "Analyze and migrate"
    },
    new: {
      title: "I want a new website",
      description: "Create a completely new website with AI help by answering a few questions",
      button: "Let's start"
    }
  },
  analysis: {
    title: "Analyzing your website",
    description: "AI is now analyzing your website and preparing it for migration",
    steps: [
      {
        icon: "search",
        title: "Downloading website",
        description: "AI is downloading and analyzing your website"
      },
      {
        icon: "brain",
        title: "Content analysis",
        description: "AI is understanding your website structure and content"
      },
      {
        icon: "download",
        title: "Preparing migration",
        description: "AI is preparing the migration to Bespire platform"
      }
    ]
  },
  benefits: [
    {
      title: "AI-powered",
      description: "Use AI to create and manage your website"
    },
    {
      title: "Quick start",
      description: "Your website is ready in minutes"
    },
    {
      title: "Professional result",
      description: "Professional website tailored to your needs"
    }
  ]
};
